export { FeatureBrandPage as BrandPage } from './lib/feature-brand-page'
export {
  getXpengStaticProps,
  getBydStaticProps,
  getJaecooStaticProps,
  getOmodaStaticProps,
  getCheryStaticProps,
} from './lib/get-static-props'
